import { VCARD_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'

export const vcardEndpoint = VCARD_API_ENDPOINT + '/api/v1/contact'
export const vcardGenEndpoint = VCARD_API_ENDPOINT + '/api/v1/card'
